module.exports = __webpack_public_path__ + "img/jian2.335942db.png";